import { render } from "./ShopProductTile.vue?vue&type=template&id=1b2230e9&scoped=true"
import script from "./ShopProductTile.vue?vue&type=script&lang=js"
export * from "./ShopProductTile.vue?vue&type=script&lang=js"

import "./ShopProductTile.vue?vue&type=style&index=0&id=1b2230e9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2230e9"]])

export default __exports__